import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, Observable, of, switchMap } from 'rxjs';

/**
 * identity
 */
import { USER_INFO_CONTROL, UserApiService, UserInfoModel } from '@identity/user';

/**
 * Route resolver that fetches user information before navigating to a route.
 * 
 * This resolver makes an API call to get the current user's information,
 * converts the response from DTO format to Model format, stores it in the
 * user service, and returns an observable that components can subscribe to.
 * 
 * If the API call fails, it returns null instead of blocking navigation.
 * 
 * @param route - The route being activated
 * @param state - The router state
 * @returns An observable that emits the user information model, or null if there's an error
 */
export const userInfoResolver: ResolveFn<Observable<UserInfoModel | null> | null> = (route, state) => {

  const _userApi = inject(UserApiService);
  const _userInfo = inject(USER_INFO_CONTROL);
  
  return _userApi
          .GET_USER_INFO() 
          .pipe(
            switchMap(response => {
              // The service will convert the DTO to a Model internally
              _userInfo.setUserInfo(response.data);

              // Return the observable so components can access the model
              return _userInfo.userInfo$;
              
            }),
            catchError(_ => of(null))
          );

};
